import { render, staticRenderFns } from "./page-with-sidebar.vue?vue&type=template&id=4a11df35&lang=pug&"
import script from "./page-with-sidebar.vue?vue&type=script&lang=js&"
export * from "./page-with-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./page-with-sidebar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports